import styled from 'styled-components';
import { breakpoints, css } from 'src/styles/theme';
import { SummaryOptionsStyled } from '../SummaryOptionsStyled';
import { rem } from 'polished';

export const SummaryOptionsStyledOV = styled(SummaryOptionsStyled)`
    &.withBorder {
        border-top: ${rem(1)} solid ${({ theme }) => theme.colors.black2};
    }

    .titleWrapper {
        .title {
            font-size: ${rem(22)};
        }

        .isClose {
            svg {
                path {
                    fill: ${({ theme }) => theme.colors.black2};
                }
            }
        }

        .isOpen {
            svg {
                path {
                    stroke: ${({ theme }) => theme.colors.black2};
                }
            }
        }
    }

    .optionsWrapper {
        .next-btn,
        .back-btn {
            border-radius: 0;

            &:disabled {
                svg {
                    path {
                        fill: ${({ theme }) => theme.colors.grey3};
                        stroke: ${({ theme }) => theme.colors.white};
                    }
                }
            }

            &:not(:disabled) {
                background: ${({ theme }) => theme.colors.white};
                border-color: ${({ theme }) => theme.colors.black2};
            }

            &:not(:disabled):hover,
            &:not(:disabled):focus-visible {
                background: ${({ theme }) => theme.colors.black2};

                svg {
                    path {
                        fill: ${({ theme }) => theme.colors.white};
                        stroke: ${({ theme }) => theme.colors.black2};
                    }
                }
            }
        }
    }
`;
